import { render, staticRenderFns } from "./AIChatMessages.vue?vue&type=template&id=ce577188&scoped=true&"
import script from "./AIChatMessages.vue?vue&type=script&lang=js&"
export * from "./AIChatMessages.vue?vue&type=script&lang=js&"
import style0 from "./AIChatMessages.vue?vue&type=style&index=0&id=ce577188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce577188",
  null
  
)

export default component.exports